import { call } from '../actions/utils';

//**** STATION CRUD
export const createRent = async (data, accessToken) =>
  await call({
    url: '/api/rent/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateRent = async (data, accessToken) =>
  await call({
    url: '/api/rent/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeRent = async (data, accessToken) =>
  await call({
    url: '/api/rent/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const endRent = async (data, accessToken) =>
  await call({
    url: '/api/rent/end',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const endRentForcibly = async (data, accessToken) =>
  await call({
    url: '/api/rent/end_forcibly',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllRents = async (data, accessToken) =>
  await call({
    url: '/api/rent/find/all',
    data: { data },
    token: accessToken
  });
export const findRentById = async (data, accessToken) =>
  await call({
    url: '/api/rent/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findRentByName = async (data, accessToken) =>
  await call({
    url: '/api/rent/by/name',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findRentsByStationId = async (data, accessToken) =>
  await call({
    url: '/api/rent/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const getRentTotal = async (data, accessToken) =>
  await call({
    url: '/api/rent/get/total',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
